export default __webpack_public_path__ + "static/boutique-others-36f22b829e853e3d1c71f03895bd5175.png";